(() => {
  const dialog = document.getElementById('YeswoodContactDialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const field = dialog.querySelector('textarea');
  const status = dialog.querySelector('[data-contact-status]');
  const copy = dialog.querySelector('[data-contact-copy]');
  const zh = dialog.dataset.language === 'zh';
  const text = (cn, en) => zh ? cn : en;
  let opener;
  let loadId = 0;

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-yeswood-contact], [data-product-inquiry], .yeswood-footer__qr-action summary');
    if (!trigger || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (trigger.matches('summary') && !trigger.closest('.yeswood-footer__qr-action').querySelector('img[src*="yeswood-contact-wecom"]')) return;
    event.preventDefault();
    opener = trigger;
    const requestId = ++loadId;
    field.value = text('你好，我想咨询 YesWood Home 的家具。', 'Hello, I would like to inquire about YesWood Home furniture.');
    status.textContent = '';
    copy.disabled = false;
    dialog.showModal();
    document.body.classList.add('yeswood-contact-open');

    if (trigger.hasAttribute('data-product-inquiry')) {
      const params = new URL(trigger.href, location.origin).searchParams;
      const productInfo = trigger.closest('product-info');
      const quantity = productInfo?.querySelector('input[name="quantity"]')?.value || '1';
      field.value = [
        'YesWood Home',
        `${text('商品', 'Product')}: ${trigger.dataset.inquiryTitle || productInfo?.querySelector('h1')?.textContent.trim() || ''}`,
        `${text('规格', 'Variant')}: ${params.get('specification') || text('默认规格', 'Default')}`,
        trigger.dataset.inquirySku ? `SKU: ${trigger.dataset.inquirySku}` : '',
        `${text('数量', 'Quantity')}: ${quantity}`,
        params.get('product') || location.href.split('#')[0],
      ].filter(Boolean).join('\n');
    } else if (trigger.dataset.yeswoodContact === 'cart' || trigger.dataset.yeswoodContactContext === 'cart') {
      copy.disabled = true;
      status.textContent = text('正在读取购物车…', 'Loading your cart…');
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (requestId !== loadId || !dialog.open) return;
        const lines = cart.items.map((item, index) => [
          `${index + 1}. ${item.product_title}`,
          item.variant_title ? `${text('规格', 'Variant')}: ${item.variant_title}` : '',
          item.sku ? `SKU: ${item.sku}` : '',
          `${text('数量', 'Quantity')}: ${item.quantity}`,
          new URL(item.url, location.origin).href,
        ].filter(Boolean).join('\n'));
        field.value = ['YesWood Home', text('我想咨询以下购物车商品：', 'I would like to inquire about these cart items:'), ...lines].join('\n\n');
        if (!lines.length) field.value = text('你好，我想咨询家具选购。我的购物车目前为空。', 'Hello, I would like advice on choosing furniture. My cart is currently empty.');
        status.textContent = '';
      } catch {
        if (requestId !== loadId || !dialog.open) return;
        field.value = '';
        status.textContent = text('购物车读取失败，请关闭后重试。你也可以直接扫码联系。', 'Unable to load your cart. Close and reopen to retry, or scan to contact us.');
      } finally {
        if (requestId === loadId) copy.disabled = !field.value;
      }
    }
  });

  copy.addEventListener('click', async () => {
    const requestId = loadId;
    try {
      await navigator.clipboard.writeText(field.value);
      if (requestId !== loadId || !dialog.open) return;
      status.textContent = text('已复制，请粘贴给顾问。', 'Copied. Paste this into your chat with the advisor.');
    } catch {
      if (requestId !== loadId || !dialog.open) return;
      field.focus();
      field.select();
      status.textContent = text('未能自动复制，请长按或使用 Ctrl/Cmd+C 复制上方内容。', 'Select the text above and copy it with your device or Ctrl/Cmd+C.');
    }
  });

  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    ++loadId;
    document.body.classList.remove('yeswood-contact-open');
    opener?.focus();
  });
})();
